<c-card *transloco="let t">
  <c-card-body class="px-2">
    <c-row>
      <c-col class="col-12 col-md-8">
        <h1>{{ t('Integrate Zapier with OK Alone') }}</h1>
        <p>
          {{ t('Use the Lone Worker by OK Alone integration on Zapier to add further functionality to OK Alone.') }}
        </p>
      </c-col>
    </c-row>
    <c-row>
      <div>
        <zapier-app-directory
          app="lone-worker-ca16559"
          linkTarget="new-tab"
          theme="light"
          [applimit]='4'
          [zaplimit]='1'
          createWithoutTemplate="show"
          useThisZap="show"
        ></zapier-app-directory>
      </div>
    </c-row>
  </c-card-body>
</c-card>

